import type { cardApiSpec } from "@wingspanhq/wingspan-api-types";
import { WSQueryConfig } from "@ws-react-query";
import { WSServiceError } from "../../../utils/serviceHelper";
import { useWSQuery } from "../../helpers";
import { getCards } from "../../../services/api/banking/cards";

export const QUERY_CARDS = "QUERY_CARDS";

export const useQueryCards = (
  config?: WSQueryConfig<cardApiSpec.Card[], WSServiceError>
) => {
  return useWSQuery<cardApiSpec.Card[], WSServiceError>(QUERY_CARDS, getCards, {
    retry: false,
    ...config
  });
};
